<!--/* eslint-disable */-->
<template>

  <div>
    <ul>
      <li v-for="file in files" :key="file.id">
        <p class="font-semibold">{{file.name}}</p>
      </li>
    </ul>
    <div>
      <file-upload
        class="vs-button bg-primary"
        v-show="files.length === 0"
        extensions="xls,xlsx"
        :multiple="false"
        :size="1024 * 1024 * 10"
        v-model="files"
        @input-filter="inputFilter"
        @input-file="inputFile"
        ref="upload">
        Selecione um arquivo
      </file-upload>
    </div>
  </div>

</template>
<style>
  .example-simple label.btn {
    margin-bottom: 0;
    margin-right: 1rem;
  }
</style>

<script>
  import FileUpload from 'vue-upload-component'
  import axios from "axios";
  export default {
    components: {
      FileUpload,
    },
    props: {
      updateValues: Function
    },
    data() {
      return {
        files: [],
        valueResponse:[],
        propostaFile: null
      }
    },
    watch: {
      files () {
        if (this.files.length === 1) {
          this.submitFile()
        }
      }
    },
    methods: {
      //Component Code
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },
      inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
          // add
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      submitFile () {
        this.propostaFile = this.files[0].file
        const formData = new FormData()
        formData.append('file', this.propostaFile)
        axios.post(`${process.env.VUE_APP_API}/api/v1/propose-form`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then((response) => {
          this.valueResponse = response.data
          this.propostaFile = null
          this.files.pop()
        })
          .catch(() => {
            this.valueResponse = []
            this.propostaFile = null
            this.files = []
          })
        .finally(()=>{
          this.updateValues();
        })
      },


    }
  }
</script>
